export const site_data = {
    "site_name": "Hochzeitsfotos"
};